import React, { memo } from 'react';

import { filterContentTypes } from '../Abstracts/Defaults';
import { useFilters } from '../../providers/FiltersProvider';

import FilterButtons from './shared/FilterButtons';

const RESOURCE_TYPE_LABEL = 'Resource Type';

const ContentTypeFilter = () => {
  const { selectedTypes, setSelectedTypes } = useFilters();

  const initialItems = filterContentTypes.map((type) => ({
    label: type,
    value: type,
  }));

  const MemoizedFilterButtons = memo(FilterButtons);

  return (
    <MemoizedFilterButtons
      initialItems={initialItems}
      label={RESOURCE_TYPE_LABEL}
      showCounter={true}
      selectedItems={selectedTypes}
      setSelectedItems={setSelectedTypes}
    />
  );
};

export default ContentTypeFilter;
